import { Blocks } from '@chameleoncreator/creator-app';
import { Mirror } from 'store/mirror';
import { remoteable } from 'store/next';
import { setBlocksLocalAction } from './setBlocksLocalAction';

export var setBlocksAction = (blocks: Blocks): any => {
  return async (dispatch, getState) => {
    const s = getState();

    const bs = Object.keys(blocks).map(key => {
      blocks[key].__isSaving = true;
      blocks[key].project_id = s.projectId;
      return blocks[key];
    });

    const localbs = bs.reduce((acc, b) => {
      acc[b.id] = b;
      return acc;
    }, {});

    dispatch(setBlocksLocalAction(localbs));

    if (remoteable()) {
      Mirror(dispatch, getState);
    }
  };
};
